module.exports = __webpack_public_path__ + "assets/08c2d74877e336f6cec05d07fd3f2a5f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/slides/bg3.png
// module id = 381
// module chunks = 1